import { atomWithStorage } from "jotai/utils";
import { atom } from "jotai";

import { ReusableViewIDs } from "../types/PageInterfaces";
import { Page } from "../types/GlobalInterfaces";
import { Field } from "../types/TenantInterfaces";

export interface SubitemDrawerAtom {
  open: boolean;
  parentRecord?: object;
  field?: Field;
  displayMode?: "SummaryCard" | string;
  moduleAPIName?: string;
  reusableViewReferenceFields?: ReusableViewIDs;
}

export type PageSettingsPage =
  | Page
  | { __Loading: boolean }
  | { __NotFound: true }
  | null;

// Whenever this atom isn't null, open page settings drawer.
export const pageSettingsAtom = atom<PageSettingsPage>(null);

// Primitive Atom Storing boolean if page header is open/collapsed
export const headerOpenAtom = atomWithStorage("headerOpen", true);

// WriteOnly Atom for toggle headerOpenAtom
export const toggleHeaderOpenAtom = atom(null, (get, set) => {
  const headerOpen = get(headerOpenAtom);

  set(headerOpenAtom, !headerOpen);
});

// Whether or not SubitemDrawer is open
export const subitemDrawerAtom = atom<SubitemDrawerAtom>({
  open: false,
});

// Whether or not SubitemDrawer is in DOM (Helps with animation)
export const showSubitemDrawerAtom = atom(false);
